module.exports = __webpack_public_path__ + "img/alleson.52561231.png";